<template>
  <div>
    <!-- 心电图 -->
    <div class="picture">
      <ecg v-if="ecgshow" :dataContent="obj.dataContent"></ecg>
    </div>
    <!-- 心率 -->
    <div class="totalBox">
      <div class="reachTheStandardTitle">心率</div>
      <div>
        <div class="numberTitle">{{obj.heartRat}}<span class="fuTitle">次/分</span></div>
        <div class="nameTitle">参考范围：60-100次/分</div>
      </div>
      <div class="component">
        <progressStatus  :wid="heartRatrate" />
      </div>
    </div>
    <!-- QT -->
    <div class="totalBox">
      <div class="reachTheStandardTitle">
        QT间期
        <div
          class="question"
          @click="
            bulletFrameIf = true;
            title = '什么是QT间期';
            name1 =
              'QT间期代表心室去极化和复极化过程的总时程，测定值随年龄和性别而变化。QT间期与心率快慢有密切关系，正常人心率加速则OT间期缩短，反之则延长。QT改变在临床心电图诊断上具有重要价值，特别是QT延长对预报恶性心室律失常和心脏性猝死有重要意义';
          "
        >
          ?
        </div>
      </div>
      <div>
        <div class="numberTitle">{{obj.qt}}<span class="fuTitle">毫秒</span></div>
        <div class="nameTitle">参考范围：300-450毫秒</div>
      </div>
      <div class="component">
        <progressStatus  :wid="qtrate" />
      </div>
    </div>
    <!-- HRV -->
    <div class="totalBox">
      <div class="reachTheStandardTitle">
        HRV
        <div
          class="question"
          :style="{ left: $px2rem(58) }"
          @click="
            bulletFrameIf = true;
            title = '什么是HRV';
            name1 =
              '心率变异性(HRV)是指逐次心跳周期差异的变化情况，它含有神经体液因素对心血管系统调节的信息，从而判断其对心血管等疾病的病情及预防，可能是预测心脏性猝死和心律失常性事件的一个有价值的指标。HRV降低为交感神经张力增高，可降低室颤阀，属不利因素;HRV升高为副交感神经张力增高，提高室额阈，属保护因素。';
          "
        >
          ?
        </div>
      </div>
      <div>
        <div class="numberTitle">{{obj.hrv}}<span class="fuTitle">毫秒</span></div>
        <div class="nameTitle">参考范围：0-230毫秒</div>
      </div>
      <div class="component">
        <progressStatus  :wid="hrvrate" :type = 'type' />
      </div>
    </div>
    <!-- ECG导联详情 -->
    <div style="padding-bottom: 80px;">
      <div class="ECG" @click="lead()">ECG导联详情</div>
    </div>
    
    <bulletFrame
      @close-method="closeMethod"
      :bulletFrameIf="bulletFrameIf"
      :title="title"
      :name="name1"
    ></bulletFrame>
  </div>
</template>
<script>
import { findecginfo } from '@/api/activity'
export default {
  data() {
    return {
      type:'HRV',
      ecgshow:false,
      title: "",
      name1: "",
      bulletFrameIf: false,
      // 区间列表数据
      list: [
        { percentage: 20, label: "舒缓放松", color: "#C94D49" },
        { width: 40, label: "热身放松", color: "orange" },
        { width: 20, label: "运动放松", color: "red" },
        { width: 20, label: "恢复放松", color: "pink" },
      ],
      heartRatrate:10,
      qtrate:100,
      hrvrate: 30, // 当前数据百分位
      obj:{},
      ecgContent:'',
    };
  },
  components: {
    progressStatus: () => import("./progressStatus"),
    ecg: () => import("./ecg"),
    bulletFrame: () => import("@/components/bulletFrame"),
  },
  computed: {},
  mounted() {
    document.title = "心电";
    document
      .querySelector("#app")
      .setAttribute("style", "background-color:#F3F4F6 !important");
      this.getData()
     
  },
  beforeCreate() {},
  methods: {
    getData() {
      var obj = {
        ecgId:this.$route.query.id
      }
      findecginfo(obj).then((res)=>{
        if(res.code == 1000) {
          this.obj = res.data
          this.heartRatrate = res.data.heartRat / 2
          if(this.heartRatrate > 100) {
            this.heartRatrate = 100
          }
          if(this.heartRatrate < 0) {
            this.heartRatrate = 0
          }
          this.qtrate = res.data.qt / 8
          if(this.qtrate > 100) {
            this.qtrate = 100
          }
          if(this.qtrate < 0) {
            this.qtrate = 0
          }
          this.hrvrate = res.data.hrv / 8 
          if(this.hrvrate > 100) {
            this.hrvrate = 100
          }
          if(this.hrvrate < 0) {
            this.hrvrate = 0
          }
          this.ecgContent = res.data.ecgContent
          this.ecgshow = true
        }
        console.log(res)
      })
    },
    lead() {
      this.$router.push({
              name: "lead",
              params:{
                ecgContent:this.ecgContent
              }
            });
    },
    closeMethod(msg) {
      this.bulletFrameIf = msg;
    },
  },
};
</script>
<style scoped>
* {
  margin: 0 auto;
  padding: 0;
  font-family: "微软雅黑";
}
.picture {
  width: 100%;
  height: 160px;
  background-color: #ffffff;
}
.totalBox {
  width: 93%;
  height: 173px;
  margin: 0 auto;
  background: #ffffff;
  border-radius: 10px;
  margin-top: 16px;
  padding: 12px 0px;
}

.numberTitle {
  font-family: HiraginoSansGB, HiraginoSansGB;
  font-weight: normal;
  font-size: 22px;
  color: #333333;
  line-height: 33px;
  text-align: center;
  font-style: normal;
}
.nameTitle {
  font-family: HiraginoSansGB, HiraginoSansGB;
  font-weight: normal;
  font-size: 13px;
  color: #999999;
  line-height: 20px;
  text-align: center;
  font-style: normal;
}
.reachTheStandardTitle {
  font-family: HiraginoSansGB, HiraginoSansGB;
  font-weight: 800;
  font-size: 16px;
  color: #333333;
  line-height: 24px;
  text-align: left;
  font-style: normal;
  padding-left: 16px;
  position: relative;
}
.fuTitle {
  font-family: HiraginoSansGB, HiraginoSansGB;
  font-weight: normal;
  font-size: 13px;
  color: #151515;
  line-height: 20px;
  text-align: right;
  font-style: normal;
}
.component {
  width: 296px;
  margin-top: 10px;
}
.question {
  width: 16px;
  height: 16px;
  color: #ffffff;
  text-align: center;
  line-height: 16px;
  border-radius: 50%;
  background: #dcdcdc;
  position: absolute;
  left: 80px;
  top: 4px;
  font-size: 13px;
}
.ECG {
  background: #00c275;
  border-radius: 30px;
  width: 93%;
  height: 44px;
  font-family: HiraginoSansGB, HiraginoSansGB;
  font-weight: normal;
  font-size: 18px;
  color: #ffffff;
  line-height: 44px;
  text-align: center;
  font-style: normal;
  margin-top: 48px;
}
.boack {
      position: absolute;
      left: 0px;
      top: 10px;
      width: 100%;
  height: 160px;
    }
</style>


// WEBPACK FOOTER //
// src/views/theHeart/index.vue